(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 820px)');

  /* mobile menu */
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { document.body.classList.add('menu-open'); });
  });
  document.querySelectorAll('[data-menu-close], .mmenu a').forEach(function (b) {
    b.addEventListener('click', function () { document.body.classList.remove('menu-open'); });
  });

  /* loader (homepage only) */
  var designMode = document.body.classList.contains('design-mode');
  var loader = document.getElementById('loader');
  if (loader && !reduced && !designMode && !sessionStorage.getItem('mx-seen')) {
    /* safety: never let the overlay stick around */
    setTimeout(function () {
      loader.classList.add('done');
      document.body.classList.add('ready');
    }, 4000);
    var pctEl = loader.querySelector('.pct');
    var p = 0;
    var pctTimer = setInterval(function () {
      p = Math.min(100, p + Math.ceil(Math.random() * 13));
      if (pctEl) pctEl.textContent = String(p).padStart(2, '0');
      if (p >= 100) {
        clearInterval(pctTimer);
        setTimeout(function () {
          loader.classList.add('done');
          document.body.classList.add('ready');
          sessionStorage.setItem('mx-seen', '1');
        }, 250);
      }
    }, 110);
  } else {
    if (loader) loader.style.display = 'none';
    document.body.classList.add('ready');
  }

  /* custom cursor */
  var cursor = document.querySelector('.cursor');
  if (cursor) {
    var cx = -100, cy = -100, tx = -100, ty = -100;
    document.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
    (function moveCursor() {
      cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      requestAnimationFrame(moveCursor);
    })();
    document.querySelectorAll('a, button, input, summary, label').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('big'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('big'); });
    });
  }

  /* hero glow + parallax */
  var hero = document.querySelector('.hero');
  if (hero) {
    var glow = hero.querySelector('.glow');
    var heroTitle = hero.querySelector('h1');
    var heroCap = hero.querySelector('.cap');
    hero.addEventListener('mousemove', function (e) {
      if (glow) {
        glow.style.setProperty('--mx', (e.clientX / window.innerWidth) * 100 + '%');
        glow.style.setProperty('--my', (e.clientY / window.innerHeight) * 100 + '%');
      }
      if (!reduced) {
        var dx = (e.clientX / window.innerWidth - 0.5);
        var dy = (e.clientY / window.innerHeight - 0.5);
        if (heroTitle) heroTitle.style.transform = 'translate(' + dx * -18 + 'px,' + dy * -10 + 'px)';
        if (heroCap) {
          heroCap.style.marginLeft = (dx * 26) + 'px';
          heroCap.style.marginTop = (dy * 18) + 'px';
        }
      }
    });
  }

  /* magnetic buttons */
  if (!reduced) {
    document.querySelectorAll('.mbtn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.25 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.35 + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1)';
        btn.style.transform = '';
        setTimeout(function () { btn.style.transition = ''; }, 500);
      });
    });
  }

  /* reveals */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.rv, .archive-strip').forEach(function (el) { io.observe(el); });

  /* animated counters */
  function runCounter(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseInt(el.dataset.to, 10) || 0;
    var suffix = el.dataset.suffix || '';
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / 1200);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(to * k).toLocaleString('en-GB') + suffix;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* craft pinned slides */
  var craft = document.querySelector('.craft');
  var slides, dots;
  if (craft) {
    slides = craft.querySelectorAll('[data-slide]');
    dots = craft.querySelectorAll('.progress i');
  }
  function craftScroll() {
    if (!craft) return;
    var r = craft.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var prog = Math.min(1, Math.max(0, -r.top / total));
    var idx = Math.min(slides.length - 1, Math.floor(prog * slides.length));
    slides.forEach(function (s, i) {
      var on = i === idx;
      s.classList.toggle('on', on);
      if (on) s.querySelectorAll('[data-counter]').forEach(runCounter);
    });
    dots.forEach(function (d, i) { d.classList.toggle('on', i <= idx); });
  }

  /* horizontal drop track */
  var wrap = document.querySelector('.dropwrap');
  var track = wrap && wrap.querySelector('.track');
  var panels = wrap ? wrap.querySelectorAll('[data-panel]') : [];
  function setDropHeight() {
    if (!wrap || !track) return;
    if (mobile.matches) { wrap.style.height = ''; track.style.transform = ''; return; }
    wrap.style.height = (track.scrollWidth - window.innerWidth + window.innerHeight) + 'px';
  }
  setDropHeight();
  window.addEventListener('resize', setDropHeight);
  function dropScroll() {
    if (!wrap || !track || mobile.matches) return;
    var r = wrap.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var prog = Math.min(1, Math.max(0, -r.top / total));
    track.style.transform = 'translateX(' + (-prog * (track.scrollWidth - window.innerWidth)) + 'px)';
    panels.forEach(function (pn) {
      var pr = pn.getBoundingClientRect();
      if (pr.left < window.innerWidth * 0.75 && pr.right > 0 && !pn.classList.contains('seen')) {
        pn.classList.add('seen');
        pn.querySelectorAll('[data-counter]').forEach(runCounter);
      }
    });
  }

  /* manchester parallax lines */
  var lines = document.querySelectorAll('.mcr .line');
  function mcrScroll() {
    lines.forEach(function (ln) {
      var sp = parseFloat(ln.dataset.speed) || 0;
      var r = ln.getBoundingClientRect();
      ln.style.transform = 'translateX(' + (r.top + r.height / 2 - window.innerHeight / 2) * sp + 'px)';
    });
  }

  function onScroll() {
    craftScroll();
    dropScroll();
    if (!reduced) mcrScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* on touch layouts, run panel counters when each card scrolls into view */
  if (panels.length) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('seen');
          en.target.querySelectorAll('[data-counter]').forEach(runCounter);
          pio.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    panels.forEach(function (pn) { pio.observe(pn); });
  }

  /* AJAX add-to-cart */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
        })
        .catch(function () {
          btn.textContent = label;
          btn.disabled = false;
          window.location.href = '/cart';
        });
    });
  });
})();
